module.exports = {
  stage: process.env.STAGE,
  apiURL: process.env.API_URL
};


// WEBPACK FOOTER //
// ../config/app.js